// extracted by mini-css-extract-plugin
export default {"closeWindowButton":"ActionScreenTopBar_closeWindowButton__8YtPL","barContainer":"ActionScreenTopBar_barContainer__-rkVS"};